import { FormattedMessage } from 'react-intl';
import React from 'react';

const prefix = 'itemExpiredErrorPage';

export function ItemExpiredErrorPage() {
  const header = <FormattedMessage id={`${prefix}.errorMessage`} defaultMessage="This item is no longer available." />;
  const subheader = (
    <FormattedMessage id={`${prefix}.errorDescription`} defaultMessage="Access to this document has expired." />
  );
  const image = '/link-expired.svg';

  return (
    <div className="view-error-page">
      <div className="content">
        <div className="center aligned custom-icon">
          <img className="ui centered small image error-image" src={image} alt="unlink" />
        </div>
      </div>
      <div className="ui hidden divider"></div>
      <div className="custom-header mark">{header}</div>
      <div className="description">
        <p> {subheader}</p>
      </div>
    </div>
  );
}
